import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { PresetCard, PresetContainer, PresetFooter, PresetGrid } from 'shared/Preset'
import { uiStore } from 'shared/store/uiStore'
import { SurveysPath } from 'entities/ExportRouters'
import { type SurveysStore } from 'pages/surveys/store/surveysStore'
import { SurveyTemplates } from 'pages/surveys/config/surveyTypes'
import styles from './styles.module.scss'

export const SurveyTypeModal = observer(({ store }: { store: SurveysStore }) => {
  const handleNext = () => {
    store.onClose()
    uiStore.changeRoute({ path: SurveysPath.create })
  }

  return (
    <PresetContainer>
      <PresetGrid className={styles.presetGrid}>
        {SurveyTemplates.map((template) => (
          <PresetCard
            key={template.type}
            icon={template.icon}
            name={template.name}
            description={template.description}
            selected={template.type === store.selectedSurveyType}
            disabled={template.disabled}
            onClick={() => store.setSelectedSurveyType(template.type)}
            badge={template.badge}
          />
        ))}
      </PresetGrid>
      <PresetFooter className={styles.footer}>
        <Button contained='secondary' size='medium' text='Cancel' onClick={store.onClose} />
        <Button typeBtn='contained' size='medium' text='Next' onClick={handleNext} />
      </PresetFooter>
    </PresetContainer>
  )
})
